module.exports = __webpack_public_path__ + "img/avatar_li_yj.3540a109.png";